<template lang="pug">
  ModalWrapper(
    icon="cog",
    :dialog="dialog",
    :header-text="$t(`form.systemSettings.${type}.${isCreate ? 'createTitle' : 'updateTitle'}`)",
    :max-width="480",
    @close="close",
  )
    template(v-slot:body="")
      TextBox(
        :error-messages="errors.name",
        :label="$t(`form.systemSettings.${type}.name`)",
        :value.sync="name"
        @update:value="clearError('name')",
      )
    template(v-slot:footer="")
      v-spacer
      v-btn(
        :disabled="isLoading",
        :ripple="false",
        color="primary",
        @click='close'
      ) {{ $t(`form.systemSettings.${type}.cancel`) }}

      v-btn(
        color="primary",
        :ripple="false",
        :loading="isLoading",
        @click="sumbit",
      ) {{ $t(`form.systemSettings.${type}.${isCreate ? 'create' : 'update'}`) }}
</template>

<script>
import TextBox from '@/components/forms/inputs/Text.vue';
import ModalWrapper from '@/components/wrapper/ModalWrapper.vue';
import { progressWrapper } from '@/config/mixins';

export default {
  mixins: [progressWrapper],

  props: {
    type: {
      type: String,
      required: true,
    },

    dialog: {
      type: Boolean,
      required: true,
    },

    item: {
      type: Object,
      required: true,
    },
  },

  components: {
    TextBox,
    ModalWrapper,
  },

  data() {
    return {
      isCreate: false,
      name: null,
      errors: {},
    };
  },

  created() {
    this.isCreate = this.item.id === undefined;
    this.name = this.item.name;
  },

  methods: {
    clearError(key) {
      this.$delete(this.errors, key);
    },

    close() {
      this.$emit('close');
    },

    sumbit() {
      this.wrapProgress(() => {
        const action = this.isCreate ? 'create' : 'update';
        const data = { name: this.name };
        const payload = this.isCreate ? { data } : { data, id: this.item.id };

        this.$store
          .dispatch(`${this.type}/${action}`, payload)
          .then(() => this.close())
          .catch(error => {
            this.errors = error.response.data.errors;
          });
      });
    },
  },
};
</script>
